import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import http from './axios'
// import {loadLanguageAsync} from '@/i18n';
// import {DEFAULT_LANGUAGE} from '@/shared/constants';

Vue.use(Router);

const router = new Router({
    mode: 'history',
    base: process.env.BASE_URL,
    routes: [
        {
            path: '/',
            redirect: {
                name: 'new-real-estate-notorious-list'
            }
        },
        {
            path: '/company/profile',
            name: 'company-profile',
            component: () => import('./views/company/profile/CompanyView'),
            meta: {
                title: 'company.profile.label',
                permission: 'V2_COMPANY_PROFILE'
            }
        },
        {
            path: '/company/edit',
            name: 'company-edit',
            component: () => import('./views/company/profile/CompanyProfileEdit'),
            meta: {
                title: 'company.edit.title',
                permission: 'V2_COMPANY_EDIT'
            }
        },
        {
            path: '/company/add',
            name: 'company-add',
            component: () => import('./views/company/profile/CompanyProfileEdit'),
            meta: {
                title: 'company.add.title',
                permission: 'V2_COMPANY_ADD'
            }
        },
        {
            path: '/company/license/add',
            name: 'company-license-add',
            component: () => import('./views/company/profile/CompanyLicenseEdit'),
            meta: {
                title: 'company.licenseAdd',
                permission: 'V2_COMPANY_ADD'
            }
        },
        {
            path: '/company/insurance/add',
            name: 'company-insurance-add',
            component: () => import('./views/company/profile/CompanyInsuranceEdit'),
            meta: {
                title: 'company.insuranceAdd',
                permission: 'V2_COMPANY_ADD'
            }
        },
        {
            path: '/company/certificate/add',
            name: 'company-certificate-add',
            component: () => import('./views/company/profile/CompanyCertificateEdit'),
            meta: {
                title: 'company.certificateAdd',
                permission: 'V2_COMPANY_ADD'
            }
        },
        {
            path: '/company/precious-metals-stones/add',
            name: 'company-precious-metals-stones-add',
            component: () => import('./views/company/profile/WorkingPreciousMetalsStonesAddEdit'),
            meta: {
                title: 'company.preciousMetalsStonesAdd',
                permission: 'V2_COMPANY_ADD'
            }
        },

        {
            path: '/real-estate/notorious',
            name: 'real-estate-notorious-list',
            component: () => import('./views/real-estate/RealEstateList'),
            meta: {
                title: 'realEstate.titleListNotorious',
                category: 'Notorious'
            }
        },
        {
            path: '/real-estate/residential',
            name: 'real-estate-residential-list',
            component: () => import('./views/real-estate/RealEstateList'),
            meta: {
                title: 'realEstate.titleListResidential',
                category: 'Residential'
            }
        },
        {
            path: '/real-estate/notorious/new',
            name: 'real-estate-notorious-new',
            component: () => import('./views/real-estate/RealEstateEdit'),
            meta: {
                title: 'realEstate.titleAddEditNotorious',
                category: 'Notorious'
            }
        },
        {
            path: '/real-estate/residential/new',
            name: 'real-estate-residential-new',
            component: () => import('./views/real-estate/RealEstateEdit'),
            meta: {
                title: 'realEstate.titleAddEditResidential',
                category: 'Residential'
            }
        },
        {
            path: '/real-estate/edit/:id',
            name: 'real-estate-edit',
            component: () => import('./views/real-estate/RealEstateEdit'),
            meta: {
                title: 'realEstate.titleAddEdit'
            }
        },
        {
            path: '/real-estate/view/:id',
            name: 'real-estate-view',
            component: () => import('./views/real-estate/RealEstateEdit'),
            meta: {
                title: 'realEstate.titleAddEdit'
            }
        },
        {
            path: '/real-estate/land/:realEstateId',
            name: 'real-estate-land-calculation',
            component: () => import('./views/real-estate/RealEstateLandCalculationView'),
            meta: {
                title: 'realEstate.land.title'
            }
        },
        {
            path: '/real-estate/coordination/:realEstateId/:isChangeStatus',
            name: 'real-estate-coordination',
            component: () => import('./views/real-estate/RealEstateCoordinationView'),
            meta: {
                title: 'realEstate.coordination.title'
            }
        },
        {
            path: '/real-estate/building/new/:realEstateId',
            name: 'real-estate-building-new',
            component: () => import('./views/real-estate/RealEstateBuildingEdit'),
            meta: {
                title: 'building.titleAddEdit'
            }
        },
        {
            path: '/real-estate/building/edit/:realEstateId/:buildingId',
            name: 'real-estate-building-edit',
            component: () => import('./views/real-estate/RealEstateBuildingEdit'),
            meta: {
                title: 'building.titleAddEdit'
            }
        },
        {
            path: '/real-estate/building/comparison/:realEstateId/:buildingId',
            name: 'real-estate-building-comparison',
            component: () => import('./views/real-estate/RealEstateBuildingComparisonView'),
            meta: {
                title: 'building.comparison.title'
            }
        },
        {
            path: '/real-estate/building/comparison-income/:realEstateId/:buildingId',
            name: 'real-estate-building-comparison-income',
            component: () => import('./views/real-estate/RealEstateBuildingComparisonIncomeView'),
            meta: {
                title: 'building.comparisonIncome.title'
            }
        },
        {
            path: '/real-estate/new/comparative',
            name: 'new-comparative',
            component: () => import('./views/real-estate/NewApproachComparativeBuilding'),
            meta: {
                title: 'building.titleAddEdit'
            }
        },
        {
            path: '/real-estate/new/income',
            name: 'new-income',
            component: () => import('./views/real-estate/NewIncomeBuilding'),
            meta: {
                title: 'building.titleAddEdit'
            }
        },
        {
            path: '/config/cadastre',
            name: 'config-cadastre',
            component: () => import('./views/config/cadastre/CadastreConfig'),
            meta: {
                title: 'config.title'
            }
        },
        {
            path: '/my-profile',
            name: 'my-profile',
            component: () => import('./views/profile/MyProfile'),
            meta: {
                title: 'profile'
            }
        },
        {
            path: '/user/list',
            name: 'user-list',
            component: () => import('./views/company/users/UserList.vue'),
            meta: {
                title: 'user.listTitle',
                requiresAuth: true,
                permission: 'V2_USERS'
            }
        },
        {
            path: '/user/add',
            name: 'user-add',
            component: () => import('./views/company/users/UserAdd.vue'),
            meta: {
                title: 'user.addNew',
                requiresAuth: true,
                permission: 'V2_USER_ADD'
            }
        },
        {
            path: '/user/:action/:id',
            name: 'user-view-edit',
            component: () => import('./views/company/users/UserEditView.vue'),
            meta: {
                title: 'user.titleEdit',
                requiresAuth: true,
                permission: 'V2_USER_EDIT'
            }
        },
        {
            path: '/config/permission',
            name: 'permission',
            component: () => import('./views/config/permission/PermissionView'),
            meta: {
                title: 'config.permission',
                requiresAuth: true,
                permission: 'PERMISSIONS',
            }
        },
        {
            path: '/config/drawPolygon',
            name: 'drawPolygon',
            component: () => import('./views/map/DrawPolygon'),
            meta: {
                title: 'config.permission'
            }
        },
        {
            path: '/config/organization-map',
            name: 'organizationMap',
            component: () => import('./views/map/OrganizationMap'),
            meta: {
                title: 'map.title',

            }
        },
        {
            path: '/reports',
            name: 'reports',
            component: () => import('./views/reports/Reports'),
            meta: {
                title: 'report.title'
            }
        },
        {
            path: '/reports/bank',
            name: 'reports-bank',
            component: () => import('./views/reports/ReportBank'),
            meta: {
                title: 'report.title'
            }
        }
        ,{
            path: '/reports/mib',
            name: 'reports-mib',
            component: () => import('./views/reports/ReportMib'),
            meta: {
                title: 'report.title'
            }
        },
        {
            path: '/reports/ssp',
            name: 'reports-ssp',
            component: () => import('./views/reports/ReportSSP'),
            meta: {
                title: 'report.title'
            }
        },
        {
            path: '/reports/appraisers/capacity',
            name: 'reports-appraisers-capacity',
            component: () => import('./views/reports/ReportAppraisersCapacity'),
            meta: {
                title: 'report.title'
            }
        },
        {
            path: '/reports/traffic/accidents',
            name: 'reports-traffic-accidents',
            component: () => import('./views/reports/ReportTrafficAccidents'),
            meta: {
                title: 'report.title'
            }
        },
        {
            path: '/reports/customs/administration',
            name: 'reports-customs-administration',
            component: () => import('./views/reports/ReportCustomsAdministration'),
            meta: {
                title: 'report.title'
            }
        },
        {
            path: '/reports/other/clients',
            name: 'reports-other_clients',
            component: () => import('./views/reports/ReportOtherClients'),
            meta: {
                title: 'report.title'
            }
        },
        {
            path: '/config/auto',
            name: 'config-auto',
            component: () => import('./views/config/auto/AutoConfig'),
            meta: {
                title: 'config.autoConfig'
            }
        },
        {
            path: '/accountBux',
            name: 'accounting.title',
            component: () => import('./views/accounting/LegalAccounting'),
            meta: {
                title: 'accounting.account.accountBook'
            }
        },
        {
            path: '/accountBuxBuilding',
            name: 'accounting.title',
            component: () => import('./views/accounting/LegalAccountingBuilding'),
            meta: {
                title: 'accounting.account.accountBook'
            }
        },
        {
            path: '/accountingAssetReport',
            name: 'accounting.title',
            component: () => import('./views/accounting/AccountingAssetReport'),
            meta: {
                title: 'accounting.account.category.accountAsset.label'
            }
        },
        {
            path: '/legalAssetReport',
            name: 'accounting.title',
            component: () => import('./views/accounting/LegalAssetReport'),
            meta: {
                title: 'accounting.titleLegalAccounting'
            }
        },
        {
            path: '/accountLeg',
            name: 'accounting.title',
            component: () => import('./views/accounting/AccountingLegalAndPhysical'),
            meta: {
                title: 'accounting.titleLegalAccounting'
            }
        },
        {
            path: '/accountLegBuilding',
            name: 'accounting.title',
            component: () => import('./views/accounting/AccountingLegalAndPhysicalBuilding'),
            meta: {
                title: 'accounting.titleLegalAccounting'
            }
        },
        {
            path: '/appraisers',
            name: 'accounting.appraisersTitle',
            component: () => import('./views/reports/Appraisers'),
            meta: {
                title: 'report.category.appraisers.label'
            }
        },
        {
            path: '/appraisersBuilding',
            name: 'accounting.appraisersTitle',
            component: () => import('./views/reports/AppraisersBuilding'),
            meta: {
                title: 'report.category.appraisersBuilding.label'
            }
        },
        {
            path: '/real-estate/esp/:realEstateId',
            name: 'real-estate-esp',
            component: () => import('./views/real-estate/RealEstateEsp.vue'),
            meta: {
                title: 'realEstate.esp.title'
            }
        },
        {
            path: '/agents',
            name: 'reports-agents',
            component: () => import('./views/reports/Agents'),
            meta: {
                title: 'report.category.agents.label'
            }
        },
        {
            path: '/agentsBuilding',
            name: 'reports-agents-building',
            component: () => import('./views/reports/AgentsBuilding'),
            meta: {
                title: 'report.category.agentsBuilding.label'
            }
        },
        {
            path: '/e-appraisal/real-estate/list',
            name: 'real-estate',
            component: () => import('./views/e-appraisal/ERealEstateList'),
            meta: {
                title: 'realEstate.titleList'
            }
        },
        {
            path: '/e-appraisal/real-estate/view/:id',
            name: 'real-estate-view',
            component: () => import('./views/e-appraisal/ERealEstateView'),
            meta: {
                title: 'realEstate.titleEAppraisalRealEstateView'
            }
        },
        {
            path: '/incomingChart',
            name: 'reports-incomingChart',
            component: () => import('./views/reports/chart/IncomingChart'),
            meta: {
                title: 'report.category.appraisersChart.label'
            }
        },
        {
            path: '/real-estate/building/regression/:realEstateId/:buildingId',
            name: 'real-estate-building-regression-model',
            component: () => import('./views/real-estate/RealEstateBuildingRegressionMethodView'),
            meta: {
                title: 'building.regressionModel.title'
            }
        },
        {
            path: '/agentChart',
            name: 'reports-agent-chart',
            component: () => import('./views/reports/chart/AgentChart'),
            meta: {
                title: 'report.category.agentChart.label'
            }
        },
        {
            path: '/asset',
            name: 'asset',
            component: () => import('./views/asset/AssetList'),
            meta: {
                title: 'asset.title'
            }
        },
        {
            path: '/asset/new',
            name: 'asset-add',
            component: () => import('./views/asset/AssetEdit'),
            meta: {
                title: 'asset.assetAdd'
            }
        },
        {
            path: '/asset/save',
            name: 'asset-save',
            component: () => import('./views/asset/AssetEdit'),
            meta: {
                title: 'asset.assetAdd'
            }
        },
        {
            path: '/asset/edit/:id',
            name: 'asset-edit',
            component: () => import('./views/asset/AssetEdit'),
            meta: {
                title: 'asset.assetEdit'
            }
        },
        {
            path: '/asset/view/:id',
            name: 'asset-view',
            component: () => import('./views/asset/AssetEdit'),
            meta: {
                title: 'asset.assetView'
            }
        },
        {
            path: '/asset/item/new/:assetId',
            name: 'asset-item-add',
            component: () => import('./views/asset/AssetItemEdit'),
            meta: {
                title: 'asset.assetEdit'
            }
        },
        {
            path: '/asset/item/edit/:id',
            name: 'asset-item-edit',
            component: () => import('./views/asset/AssetItemEdit'),
            meta: {
                title: 'asset.assetEdit'
            }
        },
        {
            path: '/asset/residential/new/:assetItemId',
            name: 'asset-residential-list',
            component: () => import('./views/asset/RealEstateOfAssetEdit'),
            meta: {
                title: 'asset.titleAddEditResidential',
                category: 'Residential'
            }
        },
        {
            path: '/asset/new-residential/new/:assetItemId',
            name: 'asset-residential-list',
            component: () => import('./views/asset/NewRealEstateOfAssetEdit'),
            meta: {
                title: 'asset.titleAddEditResidential',
                category: 'Residential'
            }
        },
        {
            path: '/asset/notorious/new/:assetItemId',
            name: 'asset-new-notorious-new',
            component: () => import('./views/asset/RealEstateOfAssetEdit'),
            meta: {
                title: 'asset.titleAddEditNotorious',
                category: 'Notorious'
            }
        },
        {
            path: '/asset/new-notorious/new/:assetItemId',
            name: 'asset-new-notorious-new',
            component: () => import('./views/asset/NewRealEstateOfAssetEdit'),
            meta: {
                title: 'asset.titleAddEditNotorious',
                category: 'Notorious'
            }
        },
        {
            path: '/asset/real-estate/edit/:id',
            name: 'asset-residential-list',
            component: () => import('./views/asset/RealEstateOfAssetEdit'),
            meta: {
                title: 'asset.titleAddEdit',
                category: 'Residential'
            }
        },
        {
            path: '/asset/new-real-estate/edit/:id',
            name: 'asset-residential-list',
            component: () => import('./views/asset/NewRealEstateOfAssetEdit'),
            meta: {
                title: 'asset.titleAddEdit',
                category: 'Residential'
            }
        },
        {
            path: '/:parentName/real-estate/land/:realEstateId',
            name: 'asset-real-estate-land-calculation',
            component: () => import('./views/real-estate/RealEstateLandCalculationView'),
            meta: {
                title: 'realEstate.land.title'
            }
        },
        {
            path: '/:parentName/real-estate/coordination/:realEstateId',
            name: 'asset-real-estate-coordination',
            component: () => import('./views/real-estate/RealEstateCoordinationView'),
            meta: {
                title: 'realEstate.coordination.title'
            }
        },
        {
            path: '/:parentName/real-estate/building/new/:realEstateId',
            name: 'asset-real-estate-building-new',
            component: () => import('./views/real-estate/RealEstateBuildingEdit'),
            meta: {
                title: 'building.titleAddEdit'
            }
        },
        {
            path: '/:parentName/real-estate/building/edit/:realEstateId/:buildingId',
            name: 'asset-real-estate-building-edit',
            component: () => import('./views/real-estate/RealEstateBuildingEdit'),
            meta: {
                title: 'building.titleAddEdit'
            }
        },
        {
            path: '/:parentName/real-estate/building/comparison/:realEstateId/:buildingId',
            name: 'asset-real-estate-building-comparison',
            component: () => import('./views/real-estate/RealEstateBuildingComparisonView'),
            meta: {
                title: 'building.comparison.title'
            }
        },
        {
            path: '/:parentName/real-estate/building/comparison-income/:realEstateId/:buildingId',
            name: 'asset-real-estate-building-comparison-income',
            component: () => import('./views/real-estate/RealEstateBuildingComparisonIncomeView'),
            meta: {
                title: 'building.comparisonIncome.title'
            }
        },
        {
            path: '/auto/item/new/:parentId',
            name: 'auto-new',
            component: () => import('./views/auto/evaluation-object-auto'),
            meta: {
                title: 'auto.addAuto'
            }
        },
        {
            path: '/auto/defect/act/:id/:parentId',
            name: 'defect-act',
            component: () => import('./views/auto/auto-defect-act'),
            meta: {
                title: 'auto.autoLoses.label'
            }
        },
        {
            path: '/auto/item/edit/:id/:parentId',
            name: 'auto-edit',
            component: () => import('./views/auto/evaluation-object-auto'),
            meta: {
                title: 'auto.editAuto'
            }
        },
        {
            path: '/asset-auto/item/new/:parentId',
            name: 'asset-auto-new',
            component: () => import('./views/auto/asset-auto'),
            meta: {
                title: 'auto.addAuto'
            }
        },
        {
            path: '/asset-auto/item/edit/:id/:parentId',
            name: 'auto-edit',
            component: () => import('./views/auto/asset-auto'),
            meta: {
                title: 'auto.editAuto'
            }
        },
        {
            path: '/asset-auto-plus/item/new/:parentId',
            name: 'asset-auto-new',
            component: () => import('./views/asset/plus/asset-plus-auto-add-edit'),
            meta: {
                title: 'auto.addAuto'
            }
        },
        {
            path: '/asset-auto-plus/item/edit/:id/:parentId',
            name: 'asset-auto-edit',
            component: () => import('./views/asset/plus/asset-plus-auto-add-edit'),
            meta: {
                title: 'auto.editAuto'
            }
        },
        {
            path: '/auto/item/edit/:id/comparative',
            name: 'auto-edit-comparative',
            component: () => import('./views/auto/ComparativeAuto'),
            meta: {
                title: 'auto.comparative'
            }
        },
        {
            path: '/fitment/item/new/:parentId',
            name: 'fitment-new',
            component: () => import('./views/fitment/evaluation-object-fitment'),
            meta: {
                title: 'fitment.fitmentAdd'
            }
        },
        {
            path: '/fitment/item/edit/:id/:parentId',
            name: 'fitment-edit',
            component: () => import('./views/fitment/evaluation-object-fitment'),
            meta: {
                title: 'fitment.fitmentEdit'
            }
        },
        {
            path: '/asset-fitment/item/new/:parentId',
            name: 'fitment-new',
            component: () => import('./views/fitment/asset-fitment'),
            meta: {
                title: 'fitment.fitmentAdd'
            }
        },
        {
            path: '/asset-fitment/item/edit/:id/:parentId',
            name: 'fitment-edit',
            component: () => import('./views/fitment/asset-fitment'),
            meta: {
                title: 'fitment.fitmentEdit'
            }
        },
        {
            path: '/asset-fitment-plus/item/new/:parentId',
            name: 'fitment-new-plus',
            component: () => import('./views/asset/plus/asset-plus-fitment-add-edit'),
            meta: {
                title: 'fitment.fitmentAdd'
            }
        },
        {
            path: '/asset-fitment-plus/item/edit/:id/:parentId',
            name: 'fitment-edit-plus',
            component: () => import('./views/asset/plus/asset-plus-fitment-add-edit'),
            meta: {
                title: 'fitment.fitmentEdit'
            }
        },
        {
            path: '/asset/esp/:assetId',
            name: 'asset/esp',
            component: () => import('./views/asset/AssetEsp.vue'),
            meta: {
                title: 'realEstate.esp.title'
            }
        },
        {
            path: '/e-appraisal/asset/list',
            name: 'e-asset',
            component: () => import('./views/e-appraisal/EAssetList'),
            meta: {
                title: 'asset.assetView'
            }
        },
        {
            path: '/e-appraisal/asset/view/:id',
            name: 'e-asset-view',
            component: () => import('./views/e-appraisal/EAssetView'),
            meta: {
                title: 'asset.assetView'
            }
        },
        {
            path: '/e-appraisal/auto/list',
            name: 'e-auto',
            component: () => import('./views/e-appraisal/EAutoList'),
            meta: {
                title: 'eAppraisal.objectType.auto.label'
            }
        },
        {
            path: '/e-appraisal/auto/view/:id',
            name: 'e-auto-view',
            component: () => import('./views/e-appraisal/EAutoView'),
            meta: {
                title: 'eAppraisal.objectType.auto.label'
            }
        },
        {
            path: '/e-appraisal/fitment/list',
            name: 'e-fitment',
            component: () => import('./views/e-appraisal/EFitmentList'),
            meta: {
                title: 'eAppraisal.objectType.fitment.label'
            }
        },
        {
            path: '/e-appraisal/fitment/view/:id',
            name: 'e-fitment-view',
            component: () => import('./views/e-appraisal/EFitmentView'),
            meta: {
                title: 'eAppraisal.objectType.fitment.label'
            }
        },

        {
            path: '/e-appraisal/fitment/view/doc/:id',
            name: 'e-fitment-view-doc',
            component: () => import('./views/e-appraisal/EFitmentViewDoc'),
            meta: {
                title: 'eAppraisal.objectType.fitment.label'
            }
        },
        {
            path: '/e-appraisal/autonc/list',
            name: 'e-autonc',
            component: () => import('./views/e-appraisal/EAutoNCList'),
            meta: {
                title: 'eAppraisal.objectType.autonc.label'
            }
        },
        {
            path: '/e-appraisal/autonc/view/:id',
            name: 'e-autonc-view',
            component: () => import('./views/e-appraisal/EAutoNCView'),
            meta: {
                title: 'eAppraisal.objectType.autonc.label'
            }
        },
        {
            path: '/e-appraisal/order/list',
            name: 'e-order-list',
            component: () => import('./views/e-appraisal/EOrderList'),
            meta: {
                title: 'eAppraisal.objectType.order.label'
            }
        },
        {
            path: '/e-appraisal/order/view/:id',
            name: 'e-order-view',
            component: () => import('./views/e-appraisal/EOrderView'),
            meta: {
                title: 'eAppraisal.objectType.order.label'
            }
        },
        {
            path: '/business',
            name: 'business',
            component: () => import('./views/business/BusinessList'),
            meta: {
                title: 'business.title'
            }
        },
        {
            path: '/business/new',
            name: 'business-add',
            component: () => import('./views/business/BusinessAddEditView'),
            meta: {
                title: 'business.add'
            }
        },
        {
            path: '/business/edit/:id',
            name: 'business-edit',
            component: () => import('./views/business/BusinessAddEditView'),
            meta: {
                title: 'business.edit'
            }
        },
        {
            path: '/business/view/:id',
            name: 'business-view',
            component: () => import('./views/business/BusinessAddEditView'),
            meta: {
                title: 'business.edit'
            }
        },
        {
            path: '/business/finance-result/edit/:id',
            name: 'business-finance-result',
            component: () => import('./views/business/BusinessFinanceResultView'),
            meta: {
                title: 'business.edit'
            }
        },
        {
            path: '/business/balance/edit/:id',
            name: 'business-balance',
            component: () => import('./views/business/BusinessBalanceView'),
            meta: {
                title: 'business.edit'
            }
        },
        {
            path: '/business/business-plan/edit/:id',
            name: 'business-business-plan',
            component: () => import('./views/business/BusinessPlanView'),
            meta: {
                title: 'business.edit'
            }
        },
        {
            path: '/business/founders/edit/:id',
            name: 'business-founders',
            component: () => import('./views/business/BusinessFoundersView'),
            meta: {
                title: 'asset.assetEdit'
            }
        },
        {
            path: '/business/business-entity/edit/:id',
            name: 'business-business-entity',
            component: () => import('./views/business/BusinessEntityHistoryView'),
            meta: {
                title: 'business.edit'
            }
        },
        {
            path: '/report-general-director/report-of-work-done/list',
            name: 'report-of-work-done-list',
            component: () => import('./views/report-general-director/ReportOfWorkDone'),
            meta: {
                title: 'asset.assetView'
            }
        },
        {
            path: '/report-general-director/company-expenses',
            name: 'company-expenses',
            component: () => import('./views/report-general-director/CompanyExpensesList'),
            meta: {
                title: 'reportGeneralDirector.category.expenses.label'
            }
        },
        {
            path: '/report-general-director/company-expenses/new',
            name: 'company-expenses/edit',
            component: () => import('./views/report-general-director/CompanyExpensesAddEditView'),
            meta: {
                title: 'reportGeneralDirector.category.expenses.label'
            }
        },
        {
            path: '/report-general-director/company-expenses/edit/:id',
            name: 'company-expenses/edit',
            component: () => import('./views/report-general-director/CompanyExpensesAddEditView'),
            meta: {
                title: 'reportGeneralDirector.category.expenses.label'
            }
        },
        {
            path: '/report-general-director/companyincome',
            name: 'companyincome',
            component: () => import('./views/report-general-director/CompanyIncomeList'),
            meta: {
                title: 'reportGeneralDirector.category.income.label'
            }
        },
        {
            path: '/report-general-director/companyincome/new',
            name: 'companyincome/edit',
            component: () => import('./views/report-general-director/CompanyIncomeAddEditView'),
            meta: {
                title: 'reportGeneralDirector.category.income.label'
            }
        },
        {
            path: '/report-general-director/companyincome/edit/:id',
            name: 'companyincome/edit',
            component: () => import('./views/report-general-director/CompanyIncomeAddEditView'),
            meta: {
                title: 'reportGeneralDirector.category.income.label'
            }
        },

        {
            path: '/report/general-director/real-time-report',
            name: 'real-time-work-done-view',
            component: () => import('./views/report-general-director/RealTimeWorkDoneView.vue'),
            meta: {
                title: 'asset.assetView'
            }
        },
        {
            path: '/config/re-evaluate',
            name: 're-evaluate',
            component: () => import('./views/config/re-evaluate/ReEvaluateConfig'),
            meta: {
                title: 'config.reEvaluate.title'
            }
        },
        {
            path: '/config/currency-rate',
            name: 'currency-rate',
            component: () => import('./views/config/currency/CurrencyRateList'),
            meta: {
                title: 'config.currency'
            }
        },
        {
            path: '/re-evaluation',
            name: 're-evaluation',
            component: () => import('./views/re-evaluation/ReEvaluation'),
            meta: {
                title: 'reEvaluation.titleList'
            }
        },
        {
            path: '/re-evaluation/new',
            name: 're-evaluation-new',
            component: () => import('./views/re-evaluation/ReEvaluationEdit'),
            meta: {
                title: 'reEvaluation.titleAddEdit'
            }
        },
        {
            path: '/re-evaluation/edit/:id',
            name: 're-evaluation-edit',
            component: () => import('./views/re-evaluation/ReEvaluationEdit'),
            meta: {
                title: 'reEvaluation.titleAddEdit'
            }
        },
        {
            path: '/re-evaluation/view/:id',
            name: 're-evaluation-view',
            component: () => import('./views/re-evaluation/ReEvaluationEdit'),
            meta: {
                title: 'reEvaluation.titleAddEdit'
            }
        },
        {
            path: '/re-evaluation/branch-item/new/:reEvaluationId',
            name: 're-evaluation-branch-item-add',
            component: () => import('./views/re-evaluation/ReEvaluationBranchItemEdit'),
            meta: {
                title: 'reEvaluation.titleAddEdit'
            }
        },
        {
            path: '/re-evaluation/branch-item/edit/:id',
            name: 're-evaluation-branch-item-edit',
            component: () => import('./views/re-evaluation/ReEvaluationBranchItemEdit'),
            meta: {
                title: 'reEvaluation.titleAddEdit'
            }
        },
        {
            path: '/uzcard/transactions',
            name: 'uz-card',
            component: () => import('./views/uzcard/UzCardTransactionsList'),
            meta: {
                title: 'finance.titleListUzCard',
                requiresAuth: true,
                permission: 'UZ_CARD_TRANSACTIONS_LIST',
            }
        },
        {
            path: '/finance/user-balance',
             name: 'user-balance',
            component: () => import('./views/uzcard/UserBalanceList'),
            meta: {
                title: 'finance.titleListUserBalance',
                requiresAuth: true,
                permission: 'USER_BALANCE',
            }
        },
        {
            path: '/finance/ipoteka/credit-transactions',
            name: 'credit-transactions',
            component: () => import('./views/finance/IpotekaCreditTransactionsList'),
            meta: {
                title: 'finance.ipoteka.titleListCredit',
                requiresAuth: true,
                permission: 'IPOTEKA_BANK_CREDIT_TRANSACTIONS_LIST',
            }
        },
        {
            path: '/finance/ipoteka/bind-credit-transactions',
            name: 'bind-credit-transactions',
            component: () => import('./views/finance/IpotekaCreditTransactionBindView'),
            meta: {
                title: 'finance.ipoteka.titleListCreditBind',
                requiresAuth: true,
                permission: 'IPOTEKA_BANK_BIND_TRANSACTIONS',
            }
        },
        {
            path: '/finance/ipoteka/debit-transactions',
            name: 'debit-transactions',
            component: () => import('./views/finance/IpotekaDebitTransactionsList'),
            meta: {
                title: 'finance.ipoteka.titleListDebit',
                requiresAuth: true,
                permission: 'IPOTEKA_BANK_DEBIT_TRANSACTIONS_LIST',
            }
        },
        {
            path: '/finance/ipoteka/fixed-expenses-list',
            name: 'fixed-expenses-list',
            component: () => import('./views/finance/debit/FixedExpensesList'),
            meta: {
                title: 'finance.ipoteka.titleListFixedExpenses',
                requiresAuth: true,
                permission: 'IPOTEKA_BANK_FIXED_EXPENSES_LIST',
            }
        },
        {
            path: '/finance/ipoteka/fixed-expenses/new',
            name: 'fixed-expenses-add',
            component: () => import('./views/finance/debit/FixedExpensesAddEditView'),
            meta: {
                title: 'finance.ipoteka.fixedExpenses.titleNew',
                requiresAuth: true,
                permission: 'IPOTEKA_BANK_FIXED_EXPENSES_EDIT',
            }
        },
        {
            path: '/finance/ipoteka/fixed-expenses/edit/:id',
            name: 'fixed-expenses-edit',
            component: () => import('./views/finance/debit/FixedExpensesAddEditView'),
            meta: {
                title: 'finance.ipoteka.fixedExpenses.titleEdit',
                requiresAuth: true,
                permission: 'IPOTEKA_BANK_FIXED_EXPENSES_ADD',
            }
        },
        {
            path: '/finance/ipoteka/fixed-expenses-ready-transfer-list',
            name: 'fixed-expenses-ready-transfer-list',
            component: () => import('./views/finance/debit/ready-transfer/FixedExpensesReadyTransferList'),
            meta: {
                title: 'finance.ipoteka.titleListFixedReadyTransferExpenses',
                requiresAuth: true,
                permission: 'IPOTEKA_BANK_FIXED_EXPENSES_READY_TRANSFER_LIST',
            }
        },
        {
            path: '/finance/ipoteka/payment-list',
            name: 'ipoteka-payment-list',
            component: () => import('./views/finance/debit/transaction/IpotekaPaymentTransactionList'),
            meta: {
                title: 'finance.ipoteka.titleIpotekaPaymentList',
                requiresAuth: true,
                permission: 'IPOTEKA_BANK_PAYMENT_TRANSACTIONS_LIST',
            }
        },
        {
            path: '/finance/ipoteka/payment/new',
            name: 'ipoteka-payment-add',
            component: () => import('./views/finance/debit/transaction/IpotekaPaymentTransactionAddEditView'),
            meta: {
                title: 'finance.ipoteka.paymentTransaction.titleNew',
                requiresAuth: true,
                permission: 'IPOTEKA_BANK_PAYMENT_TRANSACTIONS_ADD',
            }
        },
        {
            path: '/finance/ipoteka/payment/edit/:id',
            name: 'ipoteka-payment-edit',
            component: () => import('./views/finance/debit/transaction/IpotekaPaymentTransactionAddEditView'),
            meta: {
                title: 'finance.ipoteka.paymentTransaction.titleEdit',
                requiresAuth: true,
                permission: 'IPOTEKA_BANK_PAYMENT_TRANSACTIONS_EDIT',
            }
        },
        {
            path: '/real-estate/appraiser-report/esp/:realEstateId',
            name: 'real-estate-appraiser-esp',
            component: () => import('./views/real-estate/RealEstateAppraiserReportEsp.vue'),
            meta: {
                title: 'realEstate.appraiserReportEsp.title'
            }
        },
        {
            path: '/asset/appraiser-report/esp/:assetId',
            name: 'asset-appraiser-esp',
            component: () => import('./views/asset/AssetAppraiserReportEsp.vue'),
            meta: {
                title: 'asset.esp.title'
            }
        },
        {
            path: '/fitment/appraiser-report/esp/:fitmentId',
            name: 'fitment-appraiser-esp',
            component: () => import('./views/fitment/FitmentAppraiserReportEsp.vue'),
            meta: {
                title: 'fitment.esp.title'
            }
        },
        {
            path: '/config/contractRegion',
            name: 'contract-region',
            component: () => import('./views/config/contractRegion/ContractRegion'),
            meta: {
                title: 'config.contractRegion'
            }
        },
        {
            path: '/config/contractRegion/edit/:id',
            name: 'contract-region-edit',
            component: () => import('./views/config/contractRegion/ContractRegionEdit'),
            meta: {
                title: 'config.contractRegion'
            }
        },
        {
            path: '/config/contractAmount',
            name: 'contract-amount',
            component: () => import('./views/config/contractAmount/ContractAmountConfig'),
            meta: {
                title: 'config.contractAmount'
            }
        },
        {
            path: '/config/contractAmount/add',
            name: 'contract-amount-add',
            component: () => import('./views/config/contractAmount/ContractAmountAdd'),
            meta: {
                title: 'config.contractAmount'
            }
        },
        {
            path: '/config/contractAmount/view/:id',
            name: 'contract-amount-view',
            component: () => import('./views/config/contractAmount/ContractAmountAdd'),
            meta: {
                title: 'config.contractAmount'
            }
        },
        {
            path: '/currency/get-by-date',
            name: 'currency-rate-by-date',
            component: () => import('./views/config/currency/CurrencyRateByDate'),
            meta: {
                title: 'config.currency'
            }
        },
        {
            path: '/config/population-income',
            name: 'config-population-income',
            component: () => import('./views/config/population-income/PopulationIncomeConfigList.vue'),
            meta: {
                title: 'config.populationIncome.titleList'
            }
        },
        {
            path: '/config/product',
            name: 'config-product',
            component: () => import('./views/config/product/ProductConfig.vue'),
            meta: {
                title: 'config.product.title'
            }
        },
        {
            path: '/config/products',
            name: 'config-products',
            component: () => import('./views/config/product-plus/ProductConfig.vue'),
            meta: {
                title: 'config.products.title'
            }
        },
        {
            path: '/product-model/add',
            name: 'product-model-add',
            component: () => import('./views/config/product-plus/ProductModelAddEdit.vue'),
            meta: {
                title: 'auto.autoTexPassport.add'
            }
        },
        {
            path: '/product-model/edit/:id',
            name: 'product-model-edit',
            component: () => import('./views/config/product-plus/ProductModelAddEdit.vue'),
            meta: {
                title: 'auto.autoTexPassport.edit'
            }
        },
        {
            path: '/config/population-income/new',
            name: 'config-population-income-new',
            component: () => import('./views/config/population-income/PopulationIncomeConfig'),
            meta: {
                title: 'config.populationIncome.edit.title'
            }
        },
        {
            path: '/config/population-income/edit/:id',
            name: 'config-population-income-edit',
            component: () => import('./views/config/population-income/PopulationIncomeConfig'),
            meta: {
                title: 'config.populationIncome.edit.title'
            }
        },
        {
            path: '/config/rental-rates',
            name: 'rental-rates',
            component: () => import('./views/config/rental_rates/RentalRatesConfig'),
            meta: {
                title: 'config.rentalRates'
            }
        },
        {
            path: '/config/rental-rates/add',
            name: 'rental-rates',
            component: () => import('./views/config/rental_rates/RentalRatesAdd'),
            meta: {
                title: 'config.rentalRates'
            }
        },
        {
            path: '/config/coefficient-regional-zones-list',
            name: 'config-coefficient-regional-zones',
            component: () => import('./views/config/rental_rates/CoefficientRegionalZonesList'),
            meta: {
                title: 'config.rentalRates'
            }
        },
        {
            path: '/config/coefficient-regional-zones/add',
            name: 'config-coefficient-regional-zones-add',
            component: () => import('./views/config/rental_rates/CoefficientRegionalZones'),
            meta: {
                title: 'config.rentalRates'
            }
        },
        {
            path: '/new-real-estate/notorious',
            name: 'new-real-estate-notorious-list',
            component: () => import('./views/real-estate/new/NewRealEstateList'),
            meta: {
                title: 'newRealEstate.titleListNotorious',
                category: 'Notorious'
            }
        },
        {
            path: '/new-real-estate/residential',
            name: 'new-real-estate-residential-list',
            component: () => import('./views/real-estate/new/NewRealEstateList'),
            meta: {
                title: 'newRealEstate.titleListResidential',
                category: 'Residential'
            }
        },
        {
            path: '/new-real-estate/list-all',
            name: 'new-real-estate-list',
            component: () => import('./views/real-estate/new/NewRealEstateAllList'),
            meta: {
                title: 'newRealEstate.titleListResidential'
            }
        },
        {
            path: '/new-real-estate/notorious/new',
            name: 'new-real-estate-notorious-new',
            component: () => import('./views/real-estate/new/NewRealEstateEdit'),
            meta: {
                title: 'realEstate.titleAddEditNotorious',
                category: 'Notorious'
            }
        },
        {
            path: '/new-real-estate/residential/new',
            name: 'new-real-estate-residential-new',
            component: () => import('./views/real-estate/new/NewRealEstateEdit'),
            meta: {
                title: 'realEstate.titleAddEditResidential',
                category: 'Residential'
            }
        },
        {
            path: '/new-real-estate/edit/:id',
            name: 'new-real-estate-edit',
            component: () => import('./views/real-estate/new/NewRealEstateEdit'),
            meta: {
                title: 'realEstate.titleAddEdit'
            }
        },
        {
            path: '/new-real-estate/view/:id',
            name: 'new-real-estate-view',
            component: () => import('./views/real-estate/new/NewRealEstateEdit'),
            meta: {
                title: 'realEstate.titleAddEdit'
            }
        },
        {
            path: '/new-real-estate/coordination/:realEstateId/:isChangeStatus',
            name: 'new-real-estate-coordination',
            component: () => import('./views/real-estate/new/NewRealEstateCoordinationView'),
            meta: {
                title: 'realEstate.coordination.title'
            }
        },
        {
            path: '/:parentName/new-real-estate/coordination/:realEstateId/:isChangeStatus',
            name: 'new-real-estate-coordination',
            component: () => import('./views/real-estate/new/NewRealEstateCoordinationView'),
            meta: {
                title: 'realEstate.coordination.title'
            }
        },
        {
            path: '/new-real-estate/esp/:realEstateId',
            name: 'new-real-estate-esp',
            component: () => import('./views/real-estate/RealEstateEsp.vue'),
            meta: {
                title: 'realEstate.esp.title'
            }
        },
        {
            path: '/new-real-estate/appraiser-report/esp/:realEstateId',
            name: 'new-real-estate-appraiser-esp',
            component: () => import('./views/real-estate/RealEstateAppraiserReportEsp.vue'),
            meta: {
                title: 'realEstate.appraiserReportEsp.title'
            }
        },
        {
            path: '/new-real-estate/land/:realEstateId',
            name: 'new-real-estate-land-calculation',
            component: () => import('./views/real-estate/new/NewRealLandCalculationView.vue'),
            meta: {
                title: 'realEstate.land.title'
            }
        },
        {
            path: '/:parentName/new-real-estate/land/:realEstateId',
            name: 'new-real-estate-land-calculation',
            component: () => import('./views/real-estate/new/NewRealLandCalculationView.vue'),
            meta: {
                title: 'realEstate.land.title'
            }
        },
        {
            path: '/regional-leader/list',
            name: 'regional-leader-list',
            component: () => import('./views/report-general-director/regional-leader/RegionalLeaderList'),
            meta: {
                title: 'regionalLeader.titleList',
                permission: 'REGIONAL_LEADER_LIST',
            }
        },
        {
            path: '/regional-leader/new',
            name: 'regional-leader-new',
            component: () => import('./views/report-general-director/regional-leader/RegionalLeaderAddEditView'),
            meta: {
                title: 'regionalLeader.addNew'
            }
        },
        {
            path: '/regional-leader/edit/:id',
            name: 'regional-leader-edit',
            component: () => import('./views/report-general-director/regional-leader/RegionalLeaderAddEditView'),
            meta: {
                title: 'regionalLeader.addNew'
            }
        },
        {
            path: '/finance/deposit/deposit-list',
            name: 'deposit-list',
            component: () => import('./views/finance/deposit/DepositList'),
            meta: {
                title: 'finance.deposit.titleList',
                requiresAuth: true,
                permission: 'FINANCE_DEPOSIT_LIST',
            }
        },
        {
            path: '/config/tender',
            name: 'tender',
            component: () => import('./views/config/tender/TenderConfigList'),
            meta: {
                title: 'config.tender'
            }
        },
        {
            path: '/config/tender/edit/:id',
            name: 'tender-edit',
            component: () => import('./views/config/tender/TenderConfigEditView'),
            meta: {
                title: 'config.tender'
            }
        },
        {
            path: '/config/tender/new',
            name: 'tender-new',
            component: () => import('./views/config/tender/TenderConfig'),
            meta: {
                title: 'config.tender'
            }
        },

        {
            path: '/auto/comparative',
            name: 'auto-comparative',
            component: () => import('./views/auto/NewComparativeAuto'),
            meta: {
                title: 'auto.comparativeLbl'
            }
        },
        {
            path: '/tender',
            name: 'tender-list',
            component: () => import('./views/tender/TenderList'),
            meta: {
                title: 'tender.name',
                requiresAuth: true,
                permission: 'TENDER',
            }
        },
        {
            path: '/tender/salary/add-edit/:targetId/:targetType',
            name: 'tender-add-edit',
            component: () => import('./views/tender/TenderSalaryAddEdit'),
            meta: {
                title: 'tender.name',
            }
        },
        {
            path: '/config/companies-tariff',
            name: 'companies-tariff',
            component: () => import('./views/company/CompaniesTariffList'),
            meta: {
                title: 'companyTariff.listTitle',
            }
        },
        {
            path: '/config/companies-tariff/new',
            name: 'companies-tariff-new',
            component: () => import('./views/company/CompanyTariffAddEditView'),
            meta: {
                title: 'companyTariff.addNew',
            }
        },
        {
            path: '/config/companies-tariff/edit/:id',
            name: 'companies-tariff-edit',
            component: () => import('./views/company/CompanyTariffAddEditView'),
            meta: {
                title: 'companyTariff.titleEdit'
            }
        },
        {
            path: '/company-manage/company-personal-cabinet',
            name: 'company-personal-cabinet',
            component: () => import('./views/company/company-personal-cabinet/CompanyPersonalCabinetEditView'),
            meta: {
                title: 'companyManage.companyPersonalCabinet.label',
            }
        },
        {
            path: '/company-manage/company-order/new',
            name: 'company-order-add',
            component: () => import('./views/company/company-personal-cabinet/CompanyOrderAddEditView'),
            meta: {
                title: 'companyManage.companyOrder.addNew',
            }
        },
        {
            path: '/company-manage/company-order/edit/:id',
            name: 'company-order-add-edit',
            component: () => import('./views/company/company-personal-cabinet/CompanyOrderAddEditView'),
            meta: {
                title: 'companyManage.companyOrder.editTariff',
            }
        },
        {
            path: '/company-manage/company-order-piece/new',
            name: 'company-order-piece-add',
            component: () => import('./views/company/company-personal-cabinet/CompanyOrderPieceAddEditView'),
            meta: {
                title: 'companyManage.companyOrder.addPieceSale',
            }
        },
        {
            path: '/company-manage/company-order-piece/edit/:id',
            name: 'company-order-add-edit',
            component: () => import('./views/company/company-personal-cabinet/CompanyOrderPieceAddEditView'),
            meta: {
                title: 'companyManage.companyOrder.edit',
            }
        },
        {
            path: '/config/appraiserSalary',
            name: 'appraiser-salary',
            component: () => import('./views/config/appraiserSalary/AppraiserSalary'),
            meta: {
                title: 'config.appraiserSalary.title'
            }
        },
        {
            path: '/config/appraiserSalary/view/:id',
            name: 'appraiser-salary-view',
            component: () => import('./views/config/appraiserSalary/AppraiserSalaryView'),
            meta: {
                title: 'config.appraiserSalary.titleEdit'
            }
        },

        {
            path: '/config/users/add',
            name: 'users-salary-add',
            component: () => import('./views/deposit-salary/UsersSalaryAddEdit'),
            meta: {
                title: 'depositSalary.usersSalary.addTitle'
            }
        },
        {
            path: '/fitment/list',
            name: 'evaluation-fitment-list',
            component: () => import('./views/fitment/list'),
            meta: {
                title: 'fitment.label'
            }
        },
        {
            path: '/fitment/add',
            name: 'evaluation-fitment-add',
            component: () => import('./views/fitment/fitment-add-edit'),
            meta: {
                title: 'fitment.fitmentAdd'
            }
        },
        {
            path: '/fitment/edit/:id',
            name: 'evaluation-fitment-edit',
            component: () => import('./views/fitment/fitment-add-edit'),
            meta: {
                title: 'fitment.fitmentEdit'
            }
        },
        {
            path: '/fitment/plus/list',
            name: 'evaluation-fitment-plus-list',
            component: () => import('./views/fitment/plus/list'),
            meta: {
                title: 'fitment.label'
            }
        },
        {
            path: '/fitment/plus/add',
            name: 'evaluation-fitment-plus-add',
            component: () => import('./views/fitment/plus/fitment-plus-add-edit'),
            meta: {
                title: 'fitment.fitmentAdd'
            }
        },
        {
            path: '/fitment/plus/edit/:id',
            name: 'evaluation-fitment-plus-edit',
            component: () => import('./views/fitment/plus/fitment-plus-add-edit'),
            meta: {
                title: 'fitment.fitmentEdit'
            }
        },
        {
            path: '/fitment/plus/complement/:id',
            name: 'evaluation-fitment-complement',
            component: () => import('./views/fitment/plus/fitment-plus-complement'),
            meta: {
                title: 'fitment.fitmentEdit'
            }
        },
        {
            path: '/fitment/esp/:fitmentId',
            name: 'fitment/esp',
            component: () => import('./views/fitment/FitmentEsp.vue'),
            meta: {
                title: 'fitment.esp.title'
            }
        },
        {
            path: '/appraiser/salary',
            name: 'appraiser-salary-list',
            component: () => import('./views/deposit-salary/AppraiserSalaryList'),
            meta: {
                title: 'depositSalary.appraiserSalary.label'
            }
        },
        {
            path: '/appraiser/add',
            name: 'appraiser-salary-add',
            component: () => import('./views/deposit-salary/AppraiserSalaryAddEdit'),
            meta: {
                title: 'depositSalary.appraiserSalary.addTitle'
            }
        },
        {
            path: '/appraiser/view/:id',
            name: 'appraiser-salary-view',
            component: () => import('./views/deposit-salary/AppraiserSalaryAddEdit'),
            meta: {
                title: 'depositSalary.appraiserSalary.editTitle'
            }
        },
        {
            path: '/users/add',
            name: 'users-salary-add',
            component: () => import('./views/deposit-salary/UsersSalaryAddEdit'),
            meta: {
                title: 'depositSalary.usersSalary.addTitle'
            }
        },
        {
            path: '/users/view/:id',
            name: 'users-salary-view',
            component: () => import('./views/deposit-salary/UsersSalaryAddEdit'),
            meta: {
                title: 'depositSalary.usersSalary.editTitle'
            }
        },
        {
            path: '/finance/deposit/deposit-list-appraiser',
            name: 'deposit-list-appraiser',
            component: () => import('./views/finance/deposit/DepositAppraiserList'),
            meta: {
                title: 'finance.deposit.appraiser.title',
                requiresAuth: true,
                permission: 'FINANCE_DEPOSIT_LIST_APPRAISER',
            }
        },
        {
            path: '/finance/user-salary-list',
            name: 'user-salary-list',
            component: () => import('./views/finance/deposit/UserSalaryList'),
            meta: {
                title: 'finance.salary.titleList',
                requiresAuth: true,
                permission: 'FINANCE_USER_SALARY_LIST',
            }
        },
        // {
        //     path: '/finance/deposit/deposit-regional-leader-list',
        //     name: 'deposit-regional-leader-list',
        //     component: () => import('./views/finance/deposit/DepositRegionalLeaderList'),
        //     meta: {
        //         title: 'finance.deposit.regionalLeader.title',
        //         requiresAuth: true,
        //         permission: 'FINANCE_DEPOSIT_LIST_REGIONAL_LEADER',
        //     }
        // },
        {
            path: '/finance/deposit/users-balance-list',
            name: 'users-balance-list',
            component: () => import('./views/finance/balance/UsersBalance'),
            meta: {
                title: 'finance.balance.titleList',
                requiresAuth: true,
                permission: 'FINANCE_DEPOSIT_LIST_APPRAISER',
            }
        },
        {
            path: '/finance/balance/users-balance-list',
            name: 'users-balance-list',
            component: () => import('./views/finance/balance/UsersBalance'),
            meta: {
                title: 'finance.balance.titleList',
                requiresAuth: true,
                permission: 'FINANCE_USER_BALANCE_LIST',
            }
        },
        {
            path: '/finance/deposit/add/:totalCash/:role',
            name: 'deposit-add-edit',
            component: () => import('./views/finance/deposit/DepositsAddEdit'),
            meta: {
                title: 'finance.deposit.regionalLeader.title',
            }
        },
        {
            path: '/admin/payment/user-balance-payment/:url/:objectId/:objectName/:objectType',
            name: 'user-balance-paymentt',
            component: () => import('./views/payment/user-balance-payment'),
            meta: {
                title: 'realEstate.titleAddEdit'
            }
        },
        {
            path: '/config/gas-device-price',
            name: 'gas-device-price',
            component: () => import('./views/config/auto/GasDevicePrice'),
            meta: {
                title: 'config.gasDevicePrice.title'
            }
        },
        {
            path: '/new-real-estate/new-land/:realEstateId',
            name: 'new-land-calculation',
            component: () => import('./views/real-estate/new/NewLandCalculationView.vue'),
            meta: {
                title: 'realEstate.land.title'
            }
        },
        {
            path: '/:parentName/new-real-estate/new-land/:realEstateId',
            name: 'new-land-calculation',
            component: () => import('./views/real-estate/new/NewLandCalculationView.vue'),
            meta: {
                title: 'realEstate.land.title'
            }
        },
        {
            path: '/payment-balance',
            name: 'payment-balance',
            component: () => import('./views/payment/payment-balance'),
            meta: {
                title: 'paymentBalance.title',
                requiresAuth: true,
                permission: 'PAYMENT_BALANCE',
            }
        },
        {
            path: '/auto/list',
            name: 'auto-list',
            component: () => import('./views/auto/list'),
            meta: {
                title: 'auto.list'
            }
        },
        {
            path: '/auto/add',
            name: 'evaluation-auto-add',
            component: () => import('./views/auto/auto-add-edit'),
            meta: {
                title: 'auto.addAuto'
            }
        },
        {
            path: '/auto/edit/:id',
            name: 'evaluation-auto-edit',
            component: () => import('./views/auto/auto-add-edit'),
            meta: {
                title: 'auto.editAuto'
            }
        },
        {
            path: '/auto/plus/list',
            name: 'evaluation-auto-plus-list',
            component: () => import('./views/auto/plus/list'),
            meta: {
                title: 'auto.plus.list',
                requiresAuth: true,
                permission: 'AUTO_PLUS_LIST'
            }
        },
        {
            path: '/auto/plus/add',
            name: 'evaluation-auto-plus-add',
            component: () => import('./views/auto/plus/auto-plus-add-edit'),
            meta: {
                title: 'auto.plus.add'
            }
        },
        {
            path: '/auto/plus/edit/:id',
            name: 'evaluation-auto-plus-edit',
            component: () => import('./views/auto/plus/auto-plus-add-edit'),
            meta: {
                title: 'auto.plus.edit'
            }
        },
        {
            path: '/auto/loses-list',
            name: 'auto-loses-list',
            component: () => import('./views/auto/loses-list'),
            meta: {
                title: 'auto.autoLoses.list'
            }
        },
        {
            path: '/auto/loses-add',
            name: 'evaluation-auto-loses-add',
            component: () => import('./views/auto/loses-add-edit'),
            meta: {
                title: 'auto.addAuto'
            }
        },
        {
            path: '/auto/loses-edit/:id',
            name: 'evaluation-auto-loses-edit',
            component: () => import('./views/auto/loses-add-edit'),
            meta: {
                title: 'auto.editAuto'
            }
        },
        {
            path: '/auto/item-loses/new/:parentId',
            name: 'auto-loses-new',
            component: () => import('./views/auto/loses-evaluation-auto'),
            meta: {
                title: 'auto.addAuto'
            }
        },
        {
            path: '/auto/item-loses/edit/:id/:parentId',
            name: 'auto-loses-edit',
            component: () => import('./views/auto/loses-evaluation-auto'),
            meta: {
                title: 'auto.editAuto'
            }
        },

        {
            path: '/auto-manufacture/list',
            name: 'auto-manufacture-list',
            component: () => import('./views/config/auto/auto-manufacture/AutoManufacture'),
            meta: {
                title: 'auto.autoManufacture.list'
            }
        },
        {
            path: '/auto-manufacture/add',
            name: 'auto-manufacture-add',
            component: () => import('./views/config/auto/auto-manufacture/AutoManufactureAddEdit'),
            meta: {
                title: 'auto.autoManufacture.add'
            }
        },
        {
            path: '/auto-manufacture/edit/:id',
            name: 'auto-manufacture-edit',
            component: () => import('./views/config/auto/auto-manufacture/AutoManufactureAddEdit'),
            meta: {
                title: 'auto.autoManufacture.edit'
            }
        },
        {
            path: '/car-category/list',
            name: 'car-category-list',
            component: () => import('./views/config/auto/car-category/CarCategory'),
            meta: {
                title: 'auto.carCategory.list'
            }
        },
        {
            path: '/car-category/add',
            name: 'car-category-add',
            component: () => import('./views/config/auto/car-category/CarCategoryAddEdit'),
            meta: {
                title: 'auto.carCategory.add'
            }
        },
        {
            path: '/car-category/edit/:id',
            name: 'car-category-edit',
            component: () => import('./views/config/auto/car-category/CarCategoryAddEdit'),
            meta: {
                title: 'auto.carCategory.edit'
            }
        },
        {
            path: '/auto-type/list',
            name: 'auto-type-list',
            component: () => import('./views/config/auto/auto-type/AutoType'),
            meta: {
                title: 'auto.autoType.list'
            }
        },
        {
            path: '/auto-type/add',
            name: 'auto-type-add',
            component: () => import('./views/config/auto/auto-type/AutoTypeAddEdit'),
            meta: {
                title: 'auto.autoType.add'
            }
        },
        {
            path: '/auto-type/edit/:id',
            name: 'auto-type-edit',
            component: () => import('./views/config/auto/auto-type/AutoTypeAddEdit'),
            meta: {
                title: 'auto.autoType.edit'
            }
        },

        {
            path: '/car-coincidental/list',
            name: 'car-coincidental-list',
            component: () => import('./views/config/auto/car-coincidental/CarCoincidental'),
            meta: {
                title: 'auto.carCoincidental.list'
            }
        },
        {
            path: '/car-coincidental/add',
            name: 'car-coincidental-add',
            component: () => import('./views/config/auto/car-coincidental/CarCoincidentalAddEdit'),
            meta: {
                title: 'auto.carCoincidental.add'
            }
        },
        {
            path: '/car-coincidental/edit/:id',
            name: 'car-coincidental-edit',
            component: () => import('./views/config/auto/car-coincidental/CarCoincidentalAddEdit'),
            meta: {
                title: 'auto.carCoincidental.edit'
            }
        },
        {
            path: '/tex-passport/list',
            name: 'tex-passport-list',
            component: () => import('./views/config/auto/tex-passport/TexPassportList'),
            meta: {
                title: 'auto.autoTexPassport.list'
            }
        },
        {
            path: '/tex-passport/add',
            name: 'tex-passport-add',
            component: () => import('./views/config/auto/tex-passport/TexPassportAddEdit'),
            meta: {
                title: 'auto.autoTexPassport.add'
            }
        },
        {
            path: '/tex-passport/edit/:id',
            name: 'tex-passport-edit',
            component: () => import('./views/config/auto/tex-passport/TexPassportAddEdit'),
            meta: {
                title: 'auto.autoTexPassport.edit'
            }
        },
        {
            path: '/vew-auto-price-list/list',
            name: 'vew-auto-price-list',
            component: () => import('./views/config/auto/auto-price-list/AutoPriceList'),
            meta: {
                title: 'auto.newAutoPriceList.list'
            }
        },
        {
            path: '/vew-auto-price-list/add',
            name: 'vew-auto-price-list-add',
            component: () => import('./views/config/auto/auto-price-list/AutoPriceListAddEdit'),
            meta: {
                title: 'auto.newAutoPriceList.add'
            }
        },
        {
            path: '/vew-auto-price-list/edit/:id',
            name: 'vew-auto-price-list-edit',
            component: () => import('./views/config/auto/auto-price-list/AutoPriceListAddEdit'),
            meta: {
                title: 'auto.newAutoPriceList.edit'
            }
        },

        {
            path: '/finance/universal-bank/credit',
            name: 'universal-bank-credit',
            component: () => import('./views/finance2/universal-bank/UniversalBankCreditList'),
            meta: {
                title: 'finance2.universalBank.titleListCredit',
                requiresAuth: true,
                permission: 'UNIVERSAL_BANK_CREDIT_TRANSACTIONS_LIST',
            }
        },
        {
            path: '/finance/universal-bank/debit',
            name: 'universal-bank-debit',
            component: () => import('./views/finance2/universal-bank/UniversalBankDebitList'),
            meta: {
                title: 'finance2.universalBank.titleListDebit',
                requiresAuth: true,
                permission: 'UNIVERSAL_BANK_DEBIT_TRANSACTIONS_LIST',
            }
        },
        {
            path: '/finance/universal-bank/transaction/payment',
            name: 'universal-bank-payment',
            component: () => import('./views/finance2/universal-bank/transaction/UniversalBankPaymentTransactionList'),
            meta: {
                title: 'finance2.universalBank.titleTransactionList',
                requiresAuth: true,
                permission: 'UNIVERSAL_BANK_PAYMENT_TRANSACTIONS_LIST',
            }
        },
        {
            path: '/expert2/list',
            name: 'expert2-list',
            component: () => import('./views/expert2/Expert2List'),
            meta: {
                title: 'expert2.titleList',
                permission: 'EXPERT2'
            }
        },
        {
            path: '/expert2/new',
            name: 'expert2-new',
            component: () => import('./views/expert2/Expert2Edit'),
            meta: {
                title: 'expert2.titleAdd',
                permission: 'EXPERT2_ADD'
            }
        },
        {
            path: '/expert2/edit/:id',
            name: 'expert2-edit',
            component: () => import('./views/expert2/Expert2Edit'),
            meta: {
                title: 'expert2.titleEdit',
                permission: 'EXPERT2_EDIT'
            }
        },
        {
            path: '/expert2/real-estate/edit/:id',
            name: 'expert2-real-estate-edit',
            component: () => import('./views/expert2/real-estate/Expert2RealEstateEdit.vue'),
            meta: {
                title: 'expert2.titleEdit',
                permission: 'EXPERT2_EDIT'
            }
        },
        {
            path: '/expert2/auto/new',
            name: 'expert2-auto-new',
            component: () => import('./views/expert2/auto/Expert2AutoEdit'),
            meta: {
                title: 'expert2.titleAdd',
                permission: 'EXPERT2_AUTO_EDIT'
            }
        },
        {
            path: '/expert2/auto/edit/:id',
            name: 'expert2-auto-edit',
            component: () => import('./views/expert2/auto/Expert2AutoEdit'),
            meta: {
                title: 'expert2.titleEdit',
                permission: 'EXPERT2_AUTO_EDIT'
            }
        },
        {
            path: '/expert2/fitment/new',
            name: 'expert2-fitment-new',
            component: () => import('./views/expert2/fitment/Expert2FitmentEdit'),
            meta: {
                title: 'expert2.titleAdd',
                permission: 'EXPERT2_FITMENT_EDIT'
            }
        },
        {
            path: '/expert2/fitment/edit/:id',
            name: 'expert2-fitment-edit',
            component: () => import('./views/expert2/fitment/Expert2FitmentEdit'),
            meta: {
                title: 'expert2.titleEdit',
                permission: 'EXPERT2_FITMENT_EDIT'
            }
        },
        {
            path: '/config/expert2',
            name: 'config-expert2',
            component: () => import('./views/config/expert2/Expert2Config'),
            meta: {
                title: 'config.title',
                permission: 'SETTINGS_EXPERT2'
            }
        },
        {
            path: '/expert2/requirement/edit/:expert2Id',
            name: 'expert2-requirement-edit',
            component: () => import('./views/expert2/Expert2RequirementEdit'),
            meta: {
                title: 'expert2.titleEdit',
                permission: 'EXPERT2_EDIT'
            }
        },
        {
            path: '/finance/payment-code',
            name: 'finance-payment-code',
            component: () => import('./views/finance2/PaymentCodeList'),
            meta: {
                title: 'finance2.paymentCode.titleList',
                permission: 'UNIVERSAL_BANK_PAYMENT_CODE_LIST'
            }
        },
        {
            path: '/finance/universal-bank/transaction/fixed-expenses-ready-transfer-list',
            name: 'universal-bank-fixed-expenses-ready-transfer-list',
            component: () => import('./views/finance2/universal-bank/transaction/UBankFixedExpensesReadyTransferList'),
            meta: {
                title: 'finance2.universalBank.titleListFixedReadyTransferExpenses',
                requiresAuth: true,
                permission: 'UNIVERSAL_BANK_FIXED_EXPENSES_READY_TRANSFER_LIST',
            }
        },
        // Director
        {
            path: '/company/director',
            name: 'director-list',
            component: () => import('./views/company/director/DirectorList'),
            meta: {
                title: 'director.listTitle',
            }
        },
        {
            path: '/company/director/new',
            name: 'director-new',
            component: () => import('./views/company/director/DirectorAddEditView'),
            meta: {
                title: 'director.addNew',
            }
        },
        {
            path: '/company/director/edit/:id',
            name: 'director-edit',
            component: () => import('./views/company/director/DirectorAddEditView'),
            meta: {
                title: 'director.titleEdit'
            }
        },
        //End director
        {
            path: '/company-registration-certificate/new',
            name: 'director-new',
            component: () => import('./views/company/profile/CompanyRegistrationCertificateAddEditView'),
            meta: {
                title: 'companyRegistrationCertificate.addNew',
            }
        },
        {
            path: '/e-appraisal/expert2/real-estate/list',
            name: 'expert2-real-estate-list',
            component: () => import('./views/e-appraisal/EExpert2RealEstateList'),
            meta: {
                title: 'expert2.titleList'
            }
        },
        {
            path: '/e-appraisal/expert2/real-estate/view/:id',
            name: 'expert2-real-estate-view',
            component: () => import('./views/e-appraisal/EExpert2RealEstateView'),
            meta: {
                title: 'expert2.titleEAppraisalRealEstateView'
            }
        },
        {
            path: '/client/physical/list',
            name: 'client-physical-list',
            component: () => import('./views/client/ClientList'),
            meta: {
                title: 'client.titleListPhysical',
                clientType: 'Physical'
            }
        },
        {
            path: '/client/legal/list',
            name: 'client-legal-list',
            component: () => import('./views/client/ClientList'),
            meta: {
                title: 'client.titleListLegal',
                clientType: 'Legal'
            }
        },
        {
            path: '/client/physical/add',
            name: 'client-physical-add',
            component: () => import('./views/client/ClientPhysicalEdit'),
            meta: {
                title: 'client.titleAddEditPhysical',
                clientType: 'Physical'
            }
        },
        {
            path: '/client/physical/:action/:id',
            name: 'client-physical-view-edit',
            component: () => import('./views/client/ClientPhysicalEdit'),
            meta: {
                title: 'client.titleAddEditPhysical',
                clientType: 'Physical'
            }
        },
        {
            path: '/client/legal/add',
            name: 'client-legal-add',
            component: () => import('./views/client/ClientLegalEdit'),
            meta: {
                title: 'client.titleAddEditLegal',
                clientType: 'Legal'
            }
        },
        {
            path: '/client/legal/:action/:id',
            name: 'client-legal-view-edit',
            component: () => import('./views/client/ClientLegalEdit'),
            meta: {
                title: 'client.titleAddEditLegal',
                clientType: 'Legal'
            }
        },
        {
            path: '/client/physical-api/add',
            name: 'client-physical-api-add',
            component: () => import('./views/client/ClientPhysicalApiEdit'),
            meta: {
                title: 'client.titleAddEditPhysical',
                clientType: 'Physical'
            }
        },
        {
            path: '/config/sync-db-history',
            name: 'sync-db-history',
            component: () => import('./views/config/sync-db-history/SyncDbHistoryList'),
            meta: {
                title: 'config.syncDbHistory'
            }
        },
        {
            path: '/company/appraiser-helper/list',
            name: 'appraiser-helper-list',
            component: () => import('./views/company/users/AppraiserHelperList'),
            meta: {
                title: 'appraiserHelpers.listTitle',
                permission: 'V2_APPRAISER_HELPER'
            }
        },
        {
            path: '/company/appraiser-helper/:action/:id',
            name: 'appraiser-helper-view-edit',
            component: () => import('./views/company/users/AppraiserHelperEditView'),
            meta: {
                title: 'appraiserHelpers.titleEdit'
            }
        },

        {
            path: '/e-appraisal/expert2/asset/list',
            name: 'e-expert2-asset-list',
            component: () => import('./views/e-appraisal/expert2/asset/EExpert2AssetList'),
            meta: {
                title: 'expert2.titleList'
            }
        },
        {
            path: '/e-appraisal/expert2/asset/view/:id',
            name: 'e-expert2-asset-view',
            component: () => import('./views/e-appraisal/expert2/asset/EExpert2AssetView'),
            meta: {
                title: 'expert2.titleEAppraisalAssetView'
            }
        },
        {
            path: '/e-appraisal/expert2/auto/list',
            name: 'e-expert2-auto-list',
            component: () => import('./views/e-appraisal/expert2/auto/EExpert2AutoList'),
            meta: {
                title: 'expert2.titleAuto.list',
                permission: 'E_BAHOLASH_EXPERT2_AUTO'
            }
        },
        {
            path: '/e-appraisal/expert2/auto/view/:id',
            name: 'e-expert2-auto-view',
            component: () => import('./views/e-appraisal/expert2/auto/EExpert2AutoEditView'),
            meta: {
                title: 'expert2.titleAuto.view'
            }
        },

        {
            path: '/e-appraisal/expert2/losses/list',
            name: 'e-expert2-losses-list',
            component: () => import('./views/e-appraisal/expert2/losses/EExpert2LossesList'),
            meta: {
                title: 'expert2.titleLosses.list',
                permission: 'E_BAHOLASH_EXPERT2_AUTO'
            }
        },
        {
            path: '/e-appraisal/expert2/losses/view/:id',
            name: 'e-expert2-losses-view',
            component: () => import('./views/e-appraisal/expert2/losses/EExpert2LossesEditView'),
            meta: {
                title: 'expert2.titleLosses.view'
            }
        },
        {
            path: '/e-appraisal/expert2/fitment/list',
            name: 'e-expert2-fitment-list',
            component: () => import('./views/e-appraisal/expert2/fitment/EExpert2FitmentList'),
            meta: {
                title: 'expert2.titleFitment.list',
                permission: 'E_BAHOLASH_EXPERT2_FITMENT'
            }
        },
        {
            path: '/e-appraisal/expert2/fitment/view/:id',
            name: 'e-expert2-fitment-view',
            component: () => import('./views/e-appraisal/expert2/fitment/EExpert2FitmentEditView'),
            meta: {
                title: 'expert2.titleFitment.view'
            }
        },
        {
            path: '/expert2/asset/edit/:id',
            name: 'expert2-asset-edit',
            component: () => import('./views/expert2/asset/Expert2AssetEdit'),
            meta: {
                title: 'expert2.edit.assetTitle',
                permission: 'EXPERT2_ASSET_EDIT'
            }
        },
        {
            path: '/expert2/:expert2Id/auto/requirement/edit/:id',
            name: 'expert2-auto-requirement-edit',
            component: () => import('./views/expert2/auto/Expert2AutoRequirementEdit'),
            meta: {
                title: 'expert2.titleEdit',
                permission: 'EXPERT2_AUTO_EDIT'
            }
        },
        {
            path: '/expert2/:expert2Id/auto/requirement/new',
            name: 'expert2-auto-requirement-new',
            component: () => import('./views/expert2/auto/Expert2AutoRequirementAdd'),
            meta: {
                title: 'expert2.titleEdit',
                permission: 'EXPERT2_AUTO_EDIT'
            }
        },
        {
            path: '/expert2/:expert2Id/fitment/requirement/edit/:id',
            name: 'expert2-fitment-requirement-edit',
            component: () => import('./views/expert2/fitment/Expert2FitmentRequirementEdit'),
            meta: {
                title: 'expert2.titleEdit',
                permission: 'EXPERT2_FITMENT_EDIT'
            }
        },
        {
            path: '/expert2/:expert2Id/fitment/requirement/new',
            name: 'expert2-fitment-requirement-edit',
            component: () => import('./views/expert2/fitment/Expert2FitmentRequirementAdd'),
            meta: {
                title: 'expert2.titleEdit',
                permission: 'EXPERT2_FITMENT_EDIT'
            }
        },
        {
            path: '/expert2/:expert2Id/real-estate/requirement/new',
            name: 'expert2-real-estate-requirement-edit',
            component: () => import('./views/expert2/real-estate/Expert2RealEstateRequirementAdd'),
            meta: {
                title: 'expert2.add.title',
                permission: 'EXPERT2_EDIT'
            }
        },
        {
            path: '/expert2/:expert2Id/real-estate/requirement/edit/:id',
            name: 'expert2-real-estate-requirement-edit',
            component: () => import('./views/expert2/real-estate/Expert2RealEstateRequirementEdit'),
            meta: {
                title: 'expert2.edit.title',
                permission: 'EXPERT2_EDIT'
            }
        },
        {
            path: '/expert2/:expert2Id/real-estate/requirement-new/edit/:id',
            name: 'expert2-real-estate-requirement-edit',
            component: () => import('./views/expert2/real-estate/Expert2RealEstateRequirementNewEdit'),
            meta: {
                title: 'expert2.edit.title',
                permission: 'EXPERT2_EDIT'
            }
        },
        {
            path: '/expert2/:expert2Id/item-method/real-estate',
            name: 'expert2-item-method-list',
            component: () => import('./views/expert2/real-estate/Expert2RealEstateItemView.vue'),
            meta: {
                title: 'expert2.edit.title'
            }
        },
        {
            path: '/expert2/asset/:expert2Id/coordination',
            name: 'expert2-asset-coordination',
            component: () => import('./views/expert2/asset/Expert2AssetCoordinationView'),
            meta: {
                title: 'expert2.field.assetCoordination'
            }
        },
        {
            path: '/expert2/real-estate/requirement/edit/:expert2Id',
            name: 'expert2-requirement-edit',
            component: () => import('./views/expert2/real-estate/Expert2RealEstateCommonRequirementEdit.vue'),
            meta: {
                title: 'expert2.titleEdit',
                permission: 'EXPERT2_EDIT'
            }
        },
        {
            path: '/expert2/asset/requirement/edit/:expert2Id',
            name: 'expert2-asset-requirement-edit',
            component: () => import('./views/expert2/asset/Expert2AssetRequirementEdit'),
            meta: {
                title: 'expert2.edit.assetTitle'
            },
            children: [
                {
                    path: '/expert2/asset/:expert2Id/real-estate/requirement/new',
                    name: 'expert2-asset-real-estate-requirement-edit',
                    component: () => import('./views/expert2/real-estate/Expert2RealEstateRequirementAdd'),
                    meta: {
                        title: 'expert2.edit.assetTitle',
                        permission: 'EXPERT2_ASSET_EDIT'
                    }
                },
                {
                    path: '/expert2/asset/:expert2Id/real-estate/requirement/edit/:id',
                    name: 'expert2-asset-real-estate-requirement-edit',
                    component: () => import('./views/expert2/real-estate/Expert2RealEstateRequirementEdit'),
                    meta: {
                        title: 'expert2.edit.assetTitle',
                        permission: 'EXPERT2_ASSET_EDIT'
                    }
                },
                {
                    path: '/expert2/asset/:expert2Id/auto/requirement/new',
                    name: 'expert2-auto-requirement-edit',
                    component: () => import('./views/expert2/auto/Expert2AutoRequirementAdd'),
                    meta: {
                        title: 'expert2.edit.assetTitle',
                        permission: 'EXPERT2_AUTO_EDIT'
                    }
                },
                {
                    path: '/expert2/asset/:expert2Id/auto/requirement/edit/:id',
                    name: 'expert2-auto-requirement-edit',
                    component: () => import('./views/expert2/auto/Expert2AutoRequirementEdit'),
                    meta: {
                        title: 'expert2.edit.assetTitle',
                        permission: 'EXPERT2_AUTO_EDIT'
                    }
                },
                {
                    path: '/expert2/asset/:expert2Id/fitment/requirement/new',
                    name: 'expert2-fitment-requirement-edit',
                    component: () => import('./views/expert2/fitment/Expert2FitmentRequirementAdd'),
                    meta: {
                        title: 'expert2.edit.assetTitle',
                        permission: 'EXPERT2_FITMENT_EDIT'
                    }
                },
                {
                    path: '/expert2/asset/:expert2Id/fitment/requirement/edit/:id',
                    name: 'expert2-fitment-requirement-edit',
                    component: () => import('./views/expert2/fitment/Expert2FitmentRequirementEdit'),
                    meta: {
                        title: 'expert2.edit.assetTitle',
                        permission: 'EXPERT2_FITMENT_EDIT'
                    }
                },
                {
                    path: '/expert2/asset/:expert2Id/item-method/real-estate',
                    name: 'expert2-item-method-list',
                    component: () => import('./views/expert2/asset/Expert2ItemView'),
                    meta: {
                        title: 'expert2.edit.assetTitle'
                    }
                },
                {
                    path: '/expert2/asset/:expert2Id/item-method/auto',
                    name: 'expert2-item-method-list',
                    component: () => import('./views/expert2/asset/Expert2ItemAutoView'),
                    meta: {
                        title: 'expert2.edit.assetTitle'
                    }
                },
                {
                    path: '/expert2/asset/:expert2Id/item-method/fitment',
                    name: 'expert2-item-method-list',
                    component: () => import('./views/expert2/asset/Expert2ItemFitmentView'),
                    meta: {
                        title: 'expert2.edit.assetTitle'
                    }
                }
            ]
        },

        // AutoParts
        {
            path: '/auto/part',
            name: 'auto-part-list',
            component: () => import('./views/auto/loses/auto-part/list'),
            meta: {
                title: 'auto.autoParts.label',
            }
        },
        {
            path: '/auto/part/new',
            name: 'auto-part-new',
            component: () => import('./views/auto/loses/auto-part/AutoPartAddEdit'),
            meta: {
                title: 'auto.autoParts.add',
            }
        },
        {
            path: '/auto/part/edit/:id',
            name: 'auto-part-edit',
            component: () => import('./views/auto/loses/auto-part/AutoPartAddEdit'),
            meta: {
                title: 'auto.autoParts.edit'
            }
        },
        {
            path: '/auto/part/view/:id',
            name: 'auto-part-view',
            component: () => import('./views/auto/loses/auto-part/AutoPartView'),
            meta: {
                title: 'auto.autoParts.view'
            }
        },
        //End AutoParts

        // SmallAutoPart
        {
            path: '/small/auto/part',
            name: 'small-auto-part-list',
            component: () => import('./views/auto/loses/small-auto-part/list'),
            meta: {
                title: 'auto.smallAutoPart.label',
            }
        },
        {
            path: '/small/auto/part/new',
            name: 'small-auto-part-new',
            component: () => import('./views/auto/loses/small-auto-part/SmallAutoPartAddEdit'),
            meta: {
                title: 'auto.smallAutoPart.add',
            }
        },
        {
            path: '/small/auto/part/edit/:id',
            name: 'small-auto-part-edit',
            component: () => import('./views/auto/loses/small-auto-part/SmallAutoPartAddEdit'),
            meta: {
                title: 'auto.smallAutoPart.edit'
            }
        },
        {
            path: '/small/auto/part/view/:id',
            name: 'small-auto-part-view',
            component: () => import('./views/auto/loses/small-auto-part/SmallAutoPartView'),
            meta: {
                title: 'auto.smallAutoPart.view'
            }
        },
        //End SmallAutoPart

        // AutoPart NormHour
        {
            path: '/auto/part/norm-hours',
            name: 'auto-part-norm-hours-list',
            component: () => import('./views/auto/loses/norm-hour/list'),
            meta: {
                title: 'auto.autoPartsNormHours.label',
            }
        },
        {
            path: '/auto/part/norm-hours/new',
            name: 'auto-part-norm-hours-new',
            component: () => import('./views/auto/loses/norm-hour/AutoPartNormHourAddEdit'),
            meta: {
                title: 'auto.autoPartsNormHours.add',
            }
        },
        {
            path: '/auto/part/norm-hours/edit/:id',
            name: 'auto-part-norm-hours-edit',
            component: () => import('./views/auto/loses/norm-hour/AutoPartNormHourAddEdit'),
            meta: {
                title: 'auto.autoPartsNormHours.edit'
            }
        },
        {
            path: '/auto/part/norm-hours/view/:id',
            name: 'auto-part-norm-hours-view',
            component: () => import('./views/auto/loses/norm-hour/AutoPartNormHourView'),
            meta: {
                title: 'auto.autoPartsNormHours.view'
            }
        }
        //End AutoPart NormHour
        ,
        {
            path: '/new-real-estate-plus/notorious',
            name: 'new-real-estate-plus-notorious-list',
            component: () => import('./views/real-estate/new/plus/NewRealEstatePlusList'),
            meta: {
                title: 'newRealEstate.titleListNotorious',
                category: 'Notorious'
            }
        },
        {
            path: '/new-real-estate-plus/residential',
            name: 'new-real-estate-plus-residential-list',
            component: () => import('./views/real-estate/new/plus/NewRealEstatePlusList'),
            meta: {
                title: 'newRealEstate.titleListResidential',
                category: 'Residential'
            }
        },
        {
            path: '/new-real-estate-plus/edit/:id',
            name: 'new-real-estate-plus-edit',
            component: () => import('./views/real-estate/new/plus/NewRealEstatePlusEdit'),
            meta: {
                title: 'realEstate.titleAddEdit'
            }
        },
        {
            path: '/real-estate-plus/notorious/new',
            name: 'real-estate-plus-notorious-new',
            component: () => import('./components/real-estate/RealEstatePlusAdd'),
            meta: {
                title: 'realEstate.titleAddEditNotorious',
                category: 'Notorious'
            }
        },
        {
            path: '/real-estate-plus/residential/new',
            name: 'real-estate-plus-residential-new',
            component: () => import('./components/real-estate/RealEstatePlusAdd'),
            meta: {
                title: 'realEstate.titleAddEditResidential',
                category: 'Residential'
            }
        },
        {
            path: '/new-real-estate-plus/view/:id',
            name: 'new-real-estate-view-view',
            component: () => import('./views/real-estate/new/plus/NewRealEstatePlusEdit'),
            meta: {
                title: 'realEstate.titleAddEdit'
            }
        },
        {
            path: '/config/evaluation-amount',
            name: 'evaluation-amount',
            component: () => import('./views/config/evaluation-prices/EvaluationAmount'),
            meta: {
                title: 'realEstate.titleAddEdit'
            }
        },
        {
            path: '/real-estate/notorious/:realEstateId/building-evaluation',
            name: 'building-notorious-evaluation-list',
            component: () => import('./views/real-estate/new/plus/for-item/RealEstateItemList.vue'),
            meta: {
                title: 'building.titleAddEdit',
                category: 'Notorious'
            }
        },
        {
            path: '/real-estate/residential/:realEstateId/building-evaluation',
            name: 'building-residential-evaluation-list',
            component: () => import('./views/real-estate/new/plus/for-item/RealEstateItemList.vue'),
            meta: {
                title: 'building.titleAddEdit',
                category: 'Residential'
            }
        },
        {
            path: '/real-estate/notorious/:realEstateId/building-evaluation/:buildingId/new',
            name: 'new-real-estate-plus-edit',
            component: () => import('./views/real-estate/new/plus/for-item/RealEstateItemEdit.vue'),
            meta: {
                title: 'realEstate.titleAddEditNotorious',
                category: 'Notorious'
            }
        },
        {
            path: '/real-estate/residential/:realEstateId/building-evaluation/:buildingId/new',
            name: 'new-real-estate-plus-edit',
            component: () => import('./views/real-estate/new/plus/for-item/RealEstateItemEdit.vue'),
            meta: {
                title: 'realEstate.titleAddEditResidential',
                category: 'Residential'
            }
        },
        {
            path: '/real-estate/:realEstateId/building-evaluation/:buildingId/edit/:id',
            name: 'new-real-estate-plus-edit',
            component: () => import('./views/real-estate/new/plus/for-item/RealEstateItemEdit.vue'),
            meta: {
                title: 'realEstate.titleAddEdit'
            }
        },
        {
            path: '/real-estate-evaluation/edit/:id',
            name: 'new-real-estate-plus-edit',
            component: () => import('./views/real-estate/new/plus/for-item/RealEstateEvaluationEdit.vue'),
            meta: {
                title: 'realEstate.titleAddEdit'
            }
        },
        {
            path: '/new-real-estate/comparative-errors/notorious',
            name: 'comparative-errors-notorious-list',
            component: () => import('./views/real-estate/new/NewRealEstateComparativeErrorList.vue'),
            meta: {
                title: 'newRealEstate.titleListNotorious',
                category: 'Notorious',
                status: 'ErrorInPrice'
            }
        },
        {
            path: '/new-real-estate/comparative-errors/residential',
            name: 'comparative-errors-residential-list',
            component: () => import('./views/real-estate/new/NewRealEstateComparativeErrorList.vue'),
            meta: {
                title: 'newRealEstate.titleListResidential',
                category: 'Residential',
                status: 'ErrorInPrice'
            }
        },
        {
            path: '/asset-plus',
            name: 'asset-plus',
            component: () => import('./views/asset/plus/AssetPlusList'),
            meta: {
                title: 'asset.titlePlusList',
                version: 'V3'
            }
        },
        {
            path: '/asset-plus/edit/:id',
            name: 'asset-plus-edit',
            component: () => import('./views/asset/AssetEdit'),
            meta: {
                title: 'asset.assetEdit',
                version: 'V3'
            }
        },
        {
            path: '/asset-plus/item/edit/:id',
            name: 'asset-plus-item-edit',
            component: () => import('./views/asset/plus/AssetPlusItemEdit'),
            meta: {
                title: 'asset.assetEdit',
                version: 'V3'
            }
        }
    ],
    scrollBehavior (/*to, from, savedPosition*/) {
        // if (savedPosition) {
        //     return savedPosition
        // } else {
            return { x: 0, y: 0 }
        // }
    }
});

router.beforeEach((to, from, next) => {
    if (to && to.meta && to.meta.title) {
        store.dispatch('initTitle', to.meta.title);
    } else {
        store.dispatch('initTitle', '');
    }

    if (to.meta.requiresAuth) {
        http.get('profile')
            .then(res => {
                res = res.data;
                if (res.id && res.id > 0) {
                    const permissions = res.permissions;
                    if (permissions.indexOf(to.meta.permission) >= 0) {
                        next();
                    } else {
                        store.dispatch('logOut');
                    }
                }
            }, err => {
                console.log(err);
                store.dispatch('logOut');
            });
    } else {
        // console.log("requiresAuth false");
        next();
    }
    return next;
});

// router.beforeEach((to, from, next) => {
//     let lang = to.params.lang;
//     if (!lang) {
//         lang = DEFAULT_LANGUAGE;
//     }
//     loadLanguageAsync(lang).then(() => next())
// });

export default router;
